// BL-177 Step 2l: the "People" tab of the right-hand panel (»): who is in this conversation, who invited / allowed them, when
// they joined, and Leave for yourself. Invite lets someone in the conversation ask a colleague to join (with a required note).
import React from 'react';
import Button3D from '../ui/Button3D';
import { inviteSeenByText } from '../../lib/conversationAccess';

const VIA_TEXT = {
    take: () => 'Took it',
    join_request: (by) => `Allowed by ${by}`,
    invite: (by) => `Invited by ${by}`,
    pass: (by) => `Passed by ${by}`,
};

export function joinedStamp(value) {
    const parsed = new Date(value || 0);
    if (Number.isNaN(parsed.getTime())) return '';
    return parsed.toLocaleString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

export function viaLabel(person) {
    const by = person?.added_by_name || 'a colleague';
    return (VIA_TEXT[person?.added_via] || (() => ''))(by);
}

export default function ConversationPeoplePanel({ people = [], loading = false, error = '', onInvite, onLeave, busy = false, pendingInvite = null, onWithdraw }) {
    return (
        <div className="space-y-2" data-conversation-people="true">
            <p className="font-semibold">In this conversation ({people.length})</p>
            {loading && people.length === 0 && <p>Loading…</p>}
            {error && <p role="alert" className="text-[#FCA5A5]">{error}</p>}
            <ul className="space-y-2">
                {people.map((person) => (
                    <li key={person.user_id} className="rounded border border-[#3B4D73] p-2" data-person-row={person.user_id}>
                        <div className="flex items-center justify-between gap-2">
                            <span className="font-medium">{person.name}{person.is_me ? ' (you)' : ''}</span>
                            {person.is_me && onLeave && (
                                <Button3D variant="pill" onClick={onLeave} disabled={busy} data-people-action="leave">Leave</Button3D>
                            )}
                        </div>
                        <p className="mt-0.5">{viaLabel(person)}</p>
                        <p className="opacity-80">Joined {joinedStamp(person.joined_at)}</p>
                        {person.note && person.added_via !== 'take' && <p className="mt-0.5 break-words opacity-90">“{person.note}”</p>}
                    </li>
                ))}
            </ul>
            {pendingInvite && (
                <div className="ia-invite-card" data-pending-invite={pendingInvite.id} role="status">
                    <p className="font-semibold">{pendingInvite.kind === 'pass' ? 'Waiting for' : 'Invited:'} {pendingInvite.to_name || 'a colleague'}</p>
                    <p className="mt-0.5 break-words" data-pending-invite-note="true">Your note: “{pendingInvite.note}”</p>
                    <p className="mt-1 opacity-90" data-pending-invite-seen="true"><span className="font-semibold">What they see: </span>{inviteSeenByText(pendingInvite)}</p>
                    {onWithdraw && <Button3D variant="pill" className="mt-2" onClick={() => onWithdraw(pendingInvite.id)} disabled={busy} data-people-action="withdraw">Withdraw invite</Button3D>}
                </div>
            )}
            {onInvite && !pendingInvite && <Button3D variant="pill" onClick={onInvite} disabled={busy} data-people-action="invite">Invite a colleague…</Button3D>}
        </div>
    );
}
